import React from 'react';
import GeoMapBaseAndTarget from "./GeoMapBaseAndTarget";

const GeoMapEditor = () => (
  <GeoMapBaseAndTarget data-test="geomapBaseTargetComponent" />
);

export default GeoMapEditor;
